import { Button } from "primereact/button";
import { IHotelContact } from "../../../models/BaseModel";
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { JVInput } from "../../../shared/JVInput";
import { JVTextArea } from "../../../shared/JVTextarea";
import { JVInputMask } from "../../../shared/JVInputMask";
import { InputMask } from "primereact/inputmask";
import { classNames } from "primereact/utils";
import { JVCheckbox } from "../../../shared/JVCheckbox";

const schema = yup.object({
    hotelId: yup.number().required('Hotel is required').min(1, 'Hotel is required'),
    name: yup.string().required("Name is required").min(3, 'Min 3 Characters').max(50, 'Max 50 Characters'),
    email: yup.string().required("Email is required").email('Invalid Email'),
    phone: yup.string().required("Phone is required"),
});

interface Iprops {
    singleData: IHotelContact,
    onSuccess: () => void,
    onClose: () => void,
    toast: any
}

export const ContactForm = (props: Iprops) => {
    const [submitting, setSubmitting] = useState(false);
    const [sameAsContact, setSameAsContact] = useState(false);

    const { control, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm<IHotelContact>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false,
    });


    useEffect(() => {
        setSameAsContact(false);
        reset(props.singleData);
    }, [props.singleData]);

    const saveToDB = async (body: IHotelContact) => {
        setSubmitting(true);
        const method = props.singleData.id ? "PUT" : "POST";
        const message = props.singleData.id ? "Updated Successfully" : "Added Successfully";

        const response = await Fetch(`HotelContact${props.singleData.id ? '/' + props.singleData.id : ''}`, method, body, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.onSuccess();
        }
        setSubmitting(false);
    }

    function onSubmit(data: any) {
        saveToDB(data);
    }

    const contact = watch("phone");

    function onSameAsContact() {
        if (sameAsContact) {
            setValue("whatsApp", undefined);
            setSameAsContact(false);
        } else {
            setValue("whatsApp", contact);
            setSameAsContact(true);
        }
    }

    return (
        <>
            {/* <h5 className='mt-1'>{props.singleData.id ? 'Update Contact' : 'Add Contact'}</h5> */}
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput column={2} required label="Name" control={control} name="name" error={errors.name?.message} />
                <JVInput column={2} required label="Email" control={control} name="email" error={errors.email?.message} />
                <JVInputMask column={2} required label="Phone" mask="9999999999" control={control} name="phone" error={errors.phone?.message} />
                <div className="field col-6 md:col-6">
                    <div className="flex align-items-center my-1">
                        <label htmlFor="whatsapp">Whatsapp</label>
                        <div className="flex align-items-center ml-auto">
                            <div className="field-checkbox m-0">
                                <input type="checkbox" id="sameAsContact" checked={sameAsContact} onChange={onSameAsContact}></input>
                                <label htmlFor="sameAsContact" className="m-0">Same as contact</label>
                            </div>
                        </div>
                    </div>
                    <Controller name="whatsApp" control={control} render={({ field, fieldState }) => (
                        <InputMask {...field} mask="9999999999" className={classNames({ 'p-invalid': fieldState.invalid })} />
                    )} />
                </div>
                <JVInput column={2} label="Designation" control={control} name="designation" error={errors.designation?.message} />
                <JVCheckbox column={2} label="Is primary contact?" control={control} name="isPrimary" labelAtTop="IsPrimary" />

                <JVTextArea column={1} label="Description" control={control} name="description" error={errors.description?.message} />

                <div className="col-12 md:col-12 flex gap-4 justify-content-end mt-2">
                    <Button style={{ width: '100px' }} loading={submitting} label="SAVE" type="submit" className="p-button-rounded"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={props.onClose} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                </div>
            </form>
        </>
    );
}